"use strict";

exports.__esModule = true;
exports.ClassificationButtonPanel = ClassificationButtonPanel;
var _react = _interopRequireDefault(require("react"));
var _Panel = require("../../Core/Panel");
var _ClassificationButtonGroup = require("./ClassificationButtonGroup");
var _ClassificationButton = require("./ClassificationButton");
var _PlantStateActivities = require("../../PlantStateActivities");
var _Text = require("../../Core/Text");
var _Translator = require("../../Core/Translator");
var _OrderSelectorDefinition = require("../OrderButtonSelector/OrderSelectorDefinition");
var _excluded = ["disabled", "device", "plantStateActivities", "plantStateActivitiesDevices", "activityPredicate", "statePredicate", "onClassifyClick", "currentCycleClassify", "isCurrentCycleSelected", "children", "activitiesOrderBy"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// The order operators expect to find reasons in: the downtimes first, then
// setup and standby, then whatever else the plant defines, in its own order.
var STATE_ORDER = ["downtime.unplanned", "downtime.planned", "setup", "standby"];
var stateRank = function stateRank(stateId) {
  var index = STATE_ORDER.indexOf(stateId);
  return index === -1 ? STATE_ORDER.length : index;
};

// Stable: equal ranks keep the order they came in.
var byStateOrder = function byStateOrder(a, b) {
  return stateRank(a.stateId) - stateRank(b.stateId);
};

/**
 * Shows a list of applicable classification buttons in groups.
 */
function ClassificationButtonPanel(props) {
  var disabled = props.disabled,
    device = props.device,
    allPlantStateActivities = props.plantStateActivities,
    plantStateActivitiesDevices = props.plantStateActivitiesDevices,
    _props$activityPredic = props.activityPredicate,
    activityPredicate = _props$activityPredic === void 0 ? function () {
      return true;
    } : _props$activityPredic,
    _props$statePredicate = props.statePredicate,
    statePredicate = _props$statePredicate === void 0 ? function () {
      return true;
    } : _props$statePredicate,
    onClassifyClick = props.onClassifyClick,
    currentCycleClassify = props.currentCycleClassify,
    isCurrentCycleSelected = props.isCurrentCycleSelected,
    children = props.children,
    activitiesOrderBy = props.activitiesOrderBy,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(allPlantStateActivities);
  var activities = plantStateActivities.activities,
    states = plantStateActivities.states,
    mapping = plantStateActivities.mapping;
  var activitiesDevices = plantStateActivitiesDevices.activitiesDevices;
  var groups = [];
  var stateGroupBody = [];
  var orderedStates = states.map(function (state, index) {
    return {
      stateId: state.id,
      index: index,
      state: state
    };
  }).sort(function (a, b) {
    return byStateOrder(a, b) || a.index - b.index;
  }).map(function (item) {
    return item.state;
  });
  for (var i = 0; i < orderedStates.length; i++) {
    var state = orderedStates[i];
    if (statePredicate(state)) {
      stateGroupBody.push(/*#__PURE__*/_react["default"].createElement(_ClassificationButton.ClassificationButton, {
        key: state.id,
        "data-testid": state.id,
        disabled: disabled,
        state: state,
        onClassifyClick: onClassifyClick
      }));
    }
  }
  for (var _i = 0; _i < mapping.length; _i++) {
    var item = mapping[_i];
    var _state = (0, _PlantStateActivities.getPlantState)(states, item.stateId);
    var body = [];
    var activitiesToShow = item.activities.filter(function (activity) {
      var result = activity;
      if (activitiesDevices) {
        var activityDevices = activitiesDevices.find(function (activityDevices) {
          return activityDevices.id == activity.id;
        });
        if (activityDevices) {
          var foundDevice = activityDevices.devices.find(function (deviceUUID) {
            return deviceUUID == device.uuid;
          });
          if (foundDevice || activityDevices.devices.length == 0) {
            return result;
          }
        } else {
          return result;
        }
      } else {
        return result;
      }
    });
    if (activitiesOrderBy != null && activitiesOrderBy.hasOwnProperty("name")) {
      switch (activitiesOrderBy.name) {
        case _OrderSelectorDefinition.ORDER_SELECTOR_ALPHABETICAL:
          activitiesToShow.sort(function (a, b) {
            return (0, _PlantStateActivities.getPlantActivity)(activities, a.id).name.localeCompare((0, _PlantStateActivities.getPlantActivity)(activities, b.id).name);
          });
          break;
        case _OrderSelectorDefinition.ORDER_SELECTOR_LATEST_CREATION_TIME:
          // left intentionally empty. Activities passed to the compoment are sorted from latest to oldest
          break;
        case _OrderSelectorDefinition.ORDER_SELECTOR_ODLEST_CREATION_TIME:
          activitiesToShow.reverse();
          break;
      }
    }
    for (var j = 0; j < activitiesToShow.length; j++) {
      var activityMapping = activitiesToShow[j];
      var rank = activityMapping.rank;
      var activity = (0, _PlantStateActivities.getPlantActivity)(activities, activityMapping.id);
      if (activityPredicate(_state)) {
        var key = _state.id + ":" + activity.id;
        body.push(/*#__PURE__*/_react["default"].createElement(_ClassificationButton.ClassificationButton, {
          key: key,
          "data-testid": "" + key,
          state: _state,
          activity: activity,
          disabled: disabled,
          rank: rank,
          onClassifyClick: onClassifyClick,
          onClickAction: activityMapping.userAction
        }));
      }
    }
    if (body.length > 0) {
      groups.push({
        stateId: _state.id,
        index: groups.length,
        element: /*#__PURE__*/_react["default"].createElement(_ClassificationButtonGroup.ClassificationButtonGroup, {
          "data-testid": "" + _state.id,
          key: _state.id,
          label: _state.name,
          state: _state
        }, body)
      });
    }
  }
  groups.sort(function (a, b) {
    return byStateOrder(a, b) || a.index - b.index;
  });
  var orderedGroups = groups.map(function (group) {
    return group.element;
  });

  // States without reasons of their own come after the reason groups.
  if (stateGroupBody.length > 0) {
    orderedGroups.push(/*#__PURE__*/_react["default"].createElement(_ClassificationButtonGroup.ClassificationButtonGroup, {
      key: "__states__"
    }, stateGroupBody));
  }
  var currentCycleClassificationMode = currentCycleClassify;
  var currentCycleClassificationText = function currentCycleClassificationText(translate) {
    if (currentCycleClassificationMode === "FROMNOW") {
      return translate("ClassificationButtonPanel.currentCycleClassify.fromNow", "Current cycle will be classified - From Time of Classification");
    }
    return translate("ClassificationButtonPanel.currentCycleClassify.entire", "Current cycle will be classified - From Start of Cycle");
  };
  var enhancedProps = Object.assign({}, extra, {
    "data-testid": "ClassificationButtonPanel"
  });
  return /*#__PURE__*/_react["default"].createElement(_Panel.Panel, enhancedProps, isCurrentCycleSelected ? /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Text.Text, null, currentCycleClassificationText(translate));
  }) : null, orderedGroups, children);
}